import { Typography } from "@material-ui/core"
import { Code, CodeBlock, CopyBlock, dracula } from "react-code-blocks"

export const ConsultaPeriodoLetivo = () => {

    const text = `GET /v1/consulta-periodos-letivos?id-unidade=28898945-eed6-4756-8a89-ad79830fa6f7
Host: api.app.juristta.com
Authorization: Bearer v1_a2f5i10a_abc123def456ghi789jk`

    const text2 = `[
    {
        "id": "c9e215cf-ee48-4fae-bf80-51aafa761759",
        "name": "2026/01",
        "description": "Primeiro semestre 2026",
        "start_at": "2026-01-01",
        "end_at": "2026-06-30"
    },
    {
        "id": "2da528ba-3026-475b-8afc-370b5338d0cb",
        "name": "2025/2",
        "description": "Segundo semestre 2025",
        "start_at": "2025-07-01",
        "end_at": "2025-12-30"
    }
]
`

    return <>
        <Typography variant="h6">Consulta de períodos letivos</Typography>
        <div style={{ marginBottom: '16px' }} />

        <Typography variant='body1'>Este endpoint permite consultar informações detalhadas de todos períodos letivos da instituição, como o id associado no sistema e as datas de início e término. Opcionalmente, pode-se passar o id de uma unidade como query para filtrar os períodos letivos da unidade desejada. </Typography>

        <div style={{ marginBlock: '16px', borderRadius: '8px', backgroundColor: '#1f1f1f', padding: '8px' }}>
            <div>
                <Typography variant="body1" component='span' style={{ fontWeight: 'bold' }}>Método:</Typography> <Typography component='span'>GET</Typography>
            </div>
            <div>
                <Typography variant="body1" component='span' style={{ fontWeight: 'bold' }}>URL:</Typography> <Typography component='span'>https://api.app.juristta.com/v1/consulta-periodos-letivos </Typography>
            </div>
            <div>
                <Typography variant="body1" component='span' style={{ fontWeight: 'bold' }}>Query (Opcional): </Typography> <Typography component='span'>id-unidade={'{'}id_unidade{'}'}</Typography>
            </div>
        </div>
        <Typography variant="h6">Exemplo de Requisição </Typography>
        <Typography variant="body1" style={{ fontFamily: 'monospace', marginBlock: '16px' }}>
            <CopyBlock codeBlockStyle={{ fontFamily: 'Arial' }} text={text} language="http" theme={dracula} codeBlock showLineNumbers />
        </Typography>


        <Typography variant="h6">Exemplo de Resposta </Typography>
        <Typography variant="body1" style={{ fontFamily: 'monospace', marginBlock: '16px' }}>
            <CodeBlock codeBlockStyle={{ fontFamily: 'Arial' }} text={text2} language="json" theme={dracula} />
        </Typography>

        <Typography variant="body1">Requisições que não seguirem corretamente a especificação receberão uma resposta com o status <Code language='http' text="HTTP 400 Bad Request." theme={dracula} ></Code> com detalhes do problema. </Typography>

    </>
}